import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {stringify} from 'qs'

import {TasksApiPath} from '../../consts'
import {mapTasksFiltersParams, mapTasksStatusesSummaryQueryParams} from '../../mappers'
import {TaskStatusCountDto, UseTasksStatusesCountsParams} from '../../types'

const QueryKey = 'tasks-statuses-count'

export const useTasksStatusesCounts = (
  params: UseTasksStatusesCountsParams,
  options?: Omit<UseQueryOptions<TaskStatusCountDto[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const {timezone, sources, assignedToMe, createdByMe, filters, areaPlantIds} = params

  return useQuery<TaskStatusCountDto[], AxiosError>({
    queryKey: [QueryKey, sources, assignedToMe, createdByMe, filters, timezone, areaPlantIds],
    queryFn: async ({signal}) => {
      const path = `${TasksApiPath.TASKS}/statuses/count`
      const response = await ApiClient.axiosInstance.post<TaskStatusCountDto[]>(
        path,
        mapTasksFiltersParams(timezone, filters, areaPlantIds),
        {
          params: mapTasksStatusesSummaryQueryParams(params),
          paramsSerializer: (params) => stringify(params, {arrayFormat: 'repeat'}),
          signal
        }
      )

      return response.data
    },
    ...options
  })
}
